var _excluded = ["className"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { tqc, forwardRef, omitThemingProps, useStyleConfig } from '../../system';
import { cx, __DEV__ } from '../../utils';
import * as React from 'react';
export var Heading = forwardRef((props, ref) => {
  var styles = useStyleConfig('Heading', props);
  var _omitThemingProps = omitThemingProps(props),
    {
      className
    } = _omitThemingProps,
    rest = _objectWithoutProperties(_omitThemingProps, _excluded);
  return /*#__PURE__*/React.createElement(tqc.h2, _extends({
    ref: ref,
    className: cx('tqc-heading', props.className)
  }, rest, {
    __css: styles
  }));
});
if (__DEV__) {
  Heading.displayName = 'Heading';
}